import { render, staticRenderFns } from "./CuriculumVitae.vue?vue&type=template&id=1c35ef24"
import script from "./CuriculumVitae.vue?vue&type=script&lang=js"
export * from "./CuriculumVitae.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports